/**
 * Hitbox Configuration
 * 
 * Centralized hitbox sizes for all interactive elements.
 * All hitboxes are scaled by HITBOX_MULTIPLIER for easier clicking.
 */

import { TILE_SIZE } from '../types';

// Global hitbox scale multiplier - increase to make clicking easier
export const HITBOX_MULTIPLIER = 1.5;

// Base hitbox sizes (before multiplier)
const AMBIENT_NPC_HITBOX_PADDING_PX = 2;
const SHARED_LARGE_INTERACTION_HITBOX_PX = 48;
const SHIPWRECK_BASE_HITBOX_WIDTH_PX = 80;
const SHIPWRECK_BASE_HITBOX_HEIGHT_PX = 70;
const BASE_SHIP_HITBOX = TILE_SIZE;
const BASE_NPC_HITBOX = TILE_SIZE;
const BASE_AMBIENT_NPC_HITBOX = TILE_SIZE * 0.5;
const BASE_RESOURCE_NODE_HITBOX = TILE_SIZE * 2;
const BASE_DEBRIS_HITBOX = SHARED_LARGE_INTERACTION_HITBOX_PX;
const BASE_LOOT_CONTAINER_HITBOX = SHARED_LARGE_INTERACTION_HITBOX_PX;

// Calculated hitbox sizes (with multiplier applied)
export const SHIP_HITBOX_RADIUS = (BASE_SHIP_HITBOX * HITBOX_MULTIPLIER) / 2;
export const NPC_HITBOX_RADIUS = (BASE_NPC_HITBOX * HITBOX_MULTIPLIER) / 2;
export const AMBIENT_NPC_HITBOX_RADIUS = (BASE_AMBIENT_NPC_HITBOX * HITBOX_MULTIPLIER) / 2 + AMBIENT_NPC_HITBOX_PADDING_PX;
export const RESOURCE_NODE_HITBOX_SIZE = BASE_RESOURCE_NODE_HITBOX * HITBOX_MULTIPLIER;
export const SHIPWRECK_HITBOX_WIDTH = SHIPWRECK_BASE_HITBOX_WIDTH_PX * HITBOX_MULTIPLIER;
export const SHIPWRECK_HITBOX_HEIGHT = SHIPWRECK_BASE_HITBOX_HEIGHT_PX * HITBOX_MULTIPLIER;
export const DEBRIS_HITBOX_SIZE = BASE_DEBRIS_HITBOX * HITBOX_MULTIPLIER;
export const LOOT_CONTAINER_HITBOX_SIZE = BASE_LOOT_CONTAINER_HITBOX * HITBOX_MULTIPLIER;

// Click tolerance for getShipAtPosition (distance-based detection)
export const SHIP_CLICK_TOLERANCE = TILE_SIZE * HITBOX_MULTIPLIER;

// Debug colors for hitbox visualization
export const HITBOX_DEBUG_COLORS = {
  ship: 0x00ff00,        // Green for ships
  npc: 0xff00ff,         // Magenta for NPCs
  ambientNpc: 0x00ffff,  // Cyan for ambient NPCs
  resourceNode: 0xffff00, // Yellow for resource nodes
  shipwreck: 0xff8800,   // Orange for shipwrecks
  debris: 0x8888ff,      // Light blue for debris
  lootContainer: 0xffd700, // Gold for loot containers
};
